module.exports = __webpack_public_path__ + "img/q2.e519ff0b.png";